import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class MentorLogsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Mentor Logs',
            ROUTE_PATH.mentorLogs,
            ROUTE_PATH.addMentor,
            false,
            false,
            8,
            false,
            false,
            ['mentorGender','mentorName','batch_number','orgname'],
            true,
            [],
            {
                isDownloadExcel: true, excelFileName: 'mentorlogs.xlsx', btnLabel: 'Download Mentor Logs', headers: [
                    { key: 'student', value: 'orgname' },
                    { key: 'batch', value: 'batch_number' },
                    { key: 'mentorName', value: 'mentorName' },
                    { key: 'mentorContact', value: 'mentorContact' },
                    { key: 'mentorGender', value: 'mentorGender' },
                    { key: 'mentorCompany', value: 'mentorCompany' },
                    { key: 'modified', value: 'modified' }
                ]
            },
            false,
            { evalKey: '', evalParam: [1], decisiveParam: false },
            false,
            false,
            false,
            null,
            { evalKey: 'is_delete', evalParam: ["0"], decisiveParam: true },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            false,
            true,
            true,
            [],
            true,
            {
                isExtraActions: false,
                btnLabel: '',
                selectOptions: [],
                selectedValue: '',
            },
            {
                isCheckboxEmit: false,
                emitKey: '',
                checkedKey: '',
                valueKey: '',
            },
            {
                isDownload: false,
                key: '',
                valueKey: '',
            },
            {
                isTabStatus: false,
                label: '',
                isChecked: false,
            },
            false,
            false


        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, true, 'text');
        const batch = new Headers('Batch', 'batch_number', false, true, 'text');
        const branch = new Headers('Branch', 'branch_name', false, true, 'text');
        const mentorName = new Headers('Mentor Name', 'mentorName', false, true, 'text');
        const mentorContact = new Headers('Mentor Contact', 'mentorContact', false, true, 'text');
        const stateName = new Headers('State', 'stateName', false, true, 'text');
        const mentorGender = new Headers('Gender', 'mentorGender', false, true, 'text');
        const mentorCompany = new Headers('Company', 'mentorCompany', false, true, 'text');
        const modified = new Headers('Date & Time', 'modified', false, true, 'text');

        //mentorCompany
        headers.push(studentName);
        headers.push(batch);
        // headers.push(branch);
        headers.push(mentorName);
        headers.push(mentorContact);
        // headers.push(stateName);
        headers.push(mentorGender);
        headers.push(mentorCompany);
        headers.push(modified);


        return headers;
    }
}